import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=bf753ddc&scoped=true&"
import script from "./AudioPlayer.vue?vue&type=script&lang=js&"
export * from "./AudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/AudioPlayer/AudioPlayer.less?vue&type=style&index=0&id=bf753ddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf753ddc",
  null
  
)

export default component.exports